import axios from 'axios';
import { resolveApiPath } from '../basePath';


const makeRequest = ({
  method, endpoint, headers, queryParameters, data, url, apiToken,
}) => {
  let requestHeaders;
  if (headers) {
    requestHeaders = { ...headers };
  } else {
    requestHeaders = {};
  }
  if (apiToken) {
    requestHeaders.Authorization = `Bearer ${apiToken}`;
  }

  let resolvedUrl = url;
  if (!resolvedUrl) {
    resolvedUrl = resolveApiPath(endpoint);
  }

  const config = {
    method,
    url: resolvedUrl,
    headers: requestHeaders,
    params: queryParameters,
    data,
  };

  return axios(config)
    .then(response => ({ response }))
    .catch((error) => {
      const errorWithContext = new Error('API request error');
      errorWithContext.responseContext = {
        response: error.response,
      };
      throw errorWithContext;
    });
};

const getSingle = ({
  endpoint, queryParameters, headers, url, apiToken,
}) => makeRequest({
  method: 'get',
  endpoint,
  queryParameters,
  apiToken,
  url,
  headers,
});

const getAll = ({
  endpoint, queryParameters, headers, url, apiToken,
}) => getSingle({
  endpoint, queryParameters, headers, url, apiToken,
}).then(result => {
  if (result.response && result.response.data && result.response.data.items && result.response.data.page && result.response.data.totalPages) {
    const items = [...result.response.data.items];
    // nextItems.push(...result.response.data.items);
    if (result.response.data.page < result.response.data.totalPages) {
      const promises = [];
      // eslint-disable-next-line no-plusplus
      for (let page = result.response.data.page + 1; page <= result.response.data.totalPages; page++) {
        const nextParameters = { ...queryParameters };
        nextParameters.page = page;
        promises.push(getSingle({
          endpoint, queryParameters: nextParameters, headers, url, apiToken,
        }));
      }
      return Promise.all(promises)
        .then(values => {
          // eslint-disable-next-line no-plusplus
          for (let r = 0; r < values.length; r++) {
            items.push(...values[r].response.data.items);
          }
          // eslint-disable-next-line no-param-reassign
          result.response.data.items = items;
          return result;
        });

      // const nextParameters = { ...queryParameters };
      // nextParameters.page = result.response.data.page + 1;
      // return getAll({
      //   endpoint, queryParameters: nextParameters, headers, url, apiToken, items: nextItems,
      // });
    }
    // // eslint-disable-next-line no-param-reassign
    // result.response.data.items = nextItems;
    return result;
  }
  return result;
});

export const apiGet = ({
  endpoint, queryParameters, headers, url, apiToken,
}) => getAll({
  endpoint, queryParameters, headers, url, apiToken,
});

export const apiDelete = ({
  endpoint, queryParameters, headers, url, apiToken,
}) => makeRequest({
  method: 'delete',
  endpoint,
  queryParameters,
  apiToken,
  url,
  headers,
});

export const apiPut = ({
  endpoint, queryParameters, data, headers, url, apiToken,
}) => makeRequest({
  method: 'put',
  endpoint,
  queryParameters,
  data,
  apiToken,
  url,
  headers,
});

export const apiPatch = ({
  endpoint, queryParameters, data, headers, url, apiToken,
}) => makeRequest({
  method: 'patch',
  endpoint,
  queryParameters,
  data,
  apiToken,
  url,
  headers,
});

export const apiPost = ({
  endpoint, queryParameters, data, headers, url, apiToken,
}) => makeRequest({
  method: 'post',
  endpoint,
  queryParameters,
  data,
  headers,
  url,
  apiToken,
});
